<template>
    <div class="invoice" id="invocie-detail" :class="{ bgBlack: isImageMode }">
        <SOSlotBase :bg-grey="false" :loading="isFetching">
            <template v-slot:title-bar>
                <div v-if="!isImageMode">
                    <SOTitleBar :type="'back'" :page-title="page.title" @back="back(page.from_route == 'invoice.create' ? -3 : -1)" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content v-if="!isFetching">
                <div
                    class="p-x-20"
                    style="position: relative"
                    :class="{ preview: camera.fullSize, 'p-t-16': !isImageMode }"
                >
                    <div v-if="!isImageMode">
                        <div
                            class="m-d-20"
                            v-for="(list, idx) in getMetodeBayar"
                            :key="`${idx}-metode-bayar`"
                            :class="{ selected: isSelectedMetode(list), unSelect: !isSelectedMetode(list) }"
                        >
                            <SOSlotCard v-if="list.isBayar" :id="`card-${idx}-metode-bayar`">
                                <template v-slot:card_body>
                                    <div class="d-grid-12 f-14" @click="doSelect(list)">
                                        <div class="grid-cspan-10 m-d-0 f-16 f-c-black f-semi">
                                            {{ list.title }}
                                        </div>
                                        <div class="grid-cspan-2 d-flex" style="justify-content: flex-end">
                                            <SORadioBtn :is-checked="isSelectedMetode(list)" />
                                        </div>
                                        <div class="grid-cspan-12">
                                            {{ list.subtitle }}
                                        </div>
                                    </div>
                                </template>
                            </SOSlotCard>
                        </div>
                    </div>
                    <div class="separator" v-if="!isImageMode"></div>
                    <div class="jml-pembayaran" :class="{ 'm-t-20': !isImageMode }">
                        <p class="m-d-12 f-14 f-reg-black" v-if="!isImageMode">Masukkan jumlah pembayaran</p>
                        <div class="m-d-20" v-if="!isImageMode">
                            <SOInputNominal
                                :use-autocomplete="false"
                                placeholder="12.345"
                                title="Nominal"
                                :prefix-left="true"
                                prefix="Rp"
                                :default-value="totalBayar | decimal"
                                :use-comma="true"
                                :disable="true"
                            />
                        </div>
                        <div class="m-d-20" v-if="!isImageMode && isTransfer">
                            <SOInputSelect
                                :required="true"
                                :placeholder="`Pilih Akun...`"
                                :options="listAkunKeuangan"
                                :selected="bayar.d_idakunbank"
                                title="Tujuan Transfer"
                                @option-selected="onInput($event, 'd_idakunbank')"
                            />
                        </div>
                    </div>
                    <div class="separator-line" v-if="!isImageMode"></div>
                    <div>
                        <SOButtonExpand
                            text="Data opsional"
                            id="optional-data"
                            :full-height="308"
                            ref="dataOptional"
                            @hook:mounted="onMountedDataOptional"
                        >
                            <template v-slot:content>
                                <div style="padding-bottom: 130px">
                                    <div
                                        class="m-d-16"
                                        id="camera-content"
                                        :class="{
                                            fullScreen: camera.open,
                                            cam2: camera.open,
                                            mT35: camera.fullSize,
                                        }"
                                    >
                                        <SOUploadNota
                                            ref="buktiMutasiRekening"
                                            id="camera-1"
                                            label="Bukti mutasi rekening"
                                            :images="buktiMutasi"
                                            :camera-open="camera.open"
                                            :full-size="camera.fullSize"
                                            :preview-img="selectedPreview"
                                            @setCamera="onToggleCamera"
                                            @setFullSize="onToggleFullSize"
                                            @setImages="setImages"
                                            @deleteImg="onDeleteImg"
                                            @preview="onSelectedImage"
                                            @hook:mounted="reloadImage"
                                        />
                                        <p class="m-d-0 m-t-4 f-12 f-reg-grey" v-if="!isImageMode">
                                            Sebagai bukti transfer rekening bank.
                                        </p>
                                    </div>
                                    <div class="m-d-16">
                                        <SOInputRegular
                                            title="No. Referensi"
                                            id="no-referensi"
                                            placeholder="2143512456341761"
                                            :value="bayar.d_noresi"
                                            autocomplete="off"
                                            @input="onInput($event, 'd_noresi')"
                                        />
                                    </div>
                                    <div class="m-d-16">
                                        <SOInputRegular
                                            title="Keterangan"
                                            id="no-referensi"
                                            placeholder="Keterangan"
                                            :value="bayar.keterangan"
                                            autocomplete="off"
                                            @input="onInput($event, 'keterangan')"
                                        />
                                    </div>
                                </div>
                            </template>
                        </SOButtonExpand>
                    </div>
                    <div class="separator-line" v-if="!isImageMode"></div>
                    <div class="row m-t-12 floating-btn col-12 btn_action_wrapper" v-if="!isImageMode">
                        <div class="f-16 f-reg-black transaksi-terpilih col-6">
                            <p class="m-d-0 f-12 f-c-midgrey">Total Pembayaran</p>
                            <p class="m-d-0">Rp {{ totalBayar | decimal }}</p>
                        </div>
                        <div class="col-6">
                            <SOButton
                                :primary="true"
                                :full="true"
                                :text="'Lunasi'"
                                :disable="!allowSave || page.saving"
                                :loading="page.saving"
                                :id="`lunasi-inv`"
                                @action="confirmLunasi()"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:modal>
                <ConfirmPayModal
                    ref="confirmPayModal"
                />
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOButton from "@/so-components/global/ui/SOButton";
import SOUploadNota from "@/so-components/global/ui/SOUploadNota.vue";
import SOButtonExpand from "@/so-components/global/ui/SOButtonExpand";
import SORadioBtn from "@/so-components/global/ui/SORadioBtn";

import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import ConfirmPayModal from "../components/modals/ConfirmPay.vue"

import metodeBayar from "../static/metodeBayar";

export default {
    name: "InvoicePembayaran",
    components: {
        SOSlotBase,
        SOSlotCard,
        SOTitleBar,
        SOLoadingPage,
        SOButton,
        SORadioBtn,
        SOButtonExpand,
        SOInputRegular,
        SOInputNominal,
        SOUploadNota,
        SOInputSelect,
        SOIconBase,
        ConfirmPayModal,
    },
    data() {
        return {
            page: {
                title: "Pembayaran",
                loading: false,
                saving: false,
                from_route: "",
            },
            dataOptional: false,
            listAkunKeuangan: [],
            selected: {},
            buktiMutasi: [],
            selectedPreview: null,
            camera: {
                open: false,
                fullSize: false,
            },
            bayar: {
                id_invoice: "",
                id_outlet: "",
                id_karyawan: "",
                tipe_bayar: 3, // Tipe bayar pelunasan
                idjenisbayar: "",
                bayar: 0,
                nominal: 0,
                d_noresi: "",
                d_nokartu: null,
                d_tanggal_transfer: "",
                d_bank: null,
                d_idakunbank: "",
                keterangan: "",
                waktu: "",
                dokumentasi: [],
            },
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.page.from_route = from.name;
        });
    },
    mounted() {
        this.init();
    },
    watch: {
        selected: function (newVal, oldVal) {
            if (newVal.id !== oldVal.id) {
                setTimeout(() => {
                    this.setCssSelected();
                }, 50);

                if (this.isTransfer) {
                    this.setAkunKeuangan();
                }

                this.updateBayar();
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            invoiceData: "invoiceData",
            dataModal: "dataModal",
        }),
        ...mapGetters("metaModule", {
            listKeuanganOwner: "getListKeuanganOwner",
        }),
        invoiceId() {
            return this.$route.params.invoiceId;
        },
        getMetodeBayar() {
            return metodeBayar;
        },
        totalBayar() {
            return this.invoiceData.total;
        },
        isFetching() {
            return this.page.loading;
        },
        isTransfer() {
            return this.selected.id === "3";
        },
        isSelectedMetode() {
            return (list) => {
                return this.selected.id === list.id;
            };
        },
        getDateNowInt() {
            return this.$moment().format("x");
        },
        isImageMode() {
            return this.camera.open || this.camera.fullSize;
        },
        allowSave() {
            if (!this.bayar.idjenisbayar) {
                return false;
            }
            if (this.bayar.idjenisbayar === 3 && !this.bayar.d_idakunbank) {
                return false;
            }
            return true;
        },
    },
    methods: {
        ...mapActions({
            getDetailInvoice: `${moduleName}/getDetailInvoice`,
            pembayaranInvoice: `${moduleName}/pembayaranInvoice`,
            getAkunKeuanganOwner: `metaModule/fetchListKeuanganOwner`,
            getDataModal: `${moduleName}/getDataModal`,
        }),
        async init() {
            await this.setFetching(true);
            await this.getDetailInvoice({ invoiceId: this.invoiceId });
            await this.getDataModal(this.invoiceId)
            this.setFetching(false);
        },
        async confirmLunasi() {
            if (this.dataModal.total) {
                await this.$refs.confirmPayModal.open(this.dataModal).then(is_with_ambil => {
                    this.onSave(is_with_ambil)
                })
            }
            else {
                this.onSave(false)
            }
        },
        async setAkunKeuangan() {
            await this.getAkunKeuanganOwner();
            this.listAkunKeuangan = [];
            this.listKeuanganOwner.forEach((v) => {
                this.listAkunKeuangan = [
                    ...this.listAkunKeuangan,
                    {
                        id: v.idakun_keuangan,
                        text: v.nama,
                    },
                ];
            });
        },
        onMountedDataOptional() {
            this.$refs.dataOptional.setExpand(this.dataOptional);
        },
        back(idx) {
            this.$router.go(idx);
        },
        goInvoiceDone(){
            this.$router.replace({ 
                name: "invoice.detail.donesuccess", 
                params: { 
                    jenis: "bayar",
                    invoiceId: this.invoiceId,
                },
                query: { sumNota: this.invoiceData.countTransaksi }
            });
        },
        setFetching(val) {
            this.page.loading = val;
        },
        setSaving(val) {
            this.page.saving = val;
        },
        onToggleCamera(val) {
            this.camera.open = val;
            this.dataOptional = true;
        },
        onToggleFullSize(val) {
            this.camera.fullSize = val;
        },
        setImages(data) {
            this.buktiMutasi = data;
        },
        onDeleteImg(idx) {
            this.buktiMutasi.splice(idx, 1);
        },
        onSelectedImage(idx) {
            this.selectedPreview = idx;
        },
        reloadImage() {
            this.$refs.buktiMutasiRekening.handleImages();
        },
        onInput(value, key) {
            this.bayar[key] = value;
        },
        doSelect(val) {
            this.selected = val;
        },
        updateBayar() {
            this.bayar.idjenisbayar = this.selected?.id | "";
            this.bayar.waktu = this.getDateNowInt;
            this.bayar.d_tanggal_transfer = this.getDateNowInt;
            this.bayar.dokumentasi = this.buktiMutasi;
            this.bayar.bayar = this.totalBayar;
            this.bayar.id_invoice = this.invoiceData.dataInvoice.idmasalTransaksi;
            this.bayar.id_karyawan = this.invoiceData.dataInvoice.idkaryawan;
            this.bayar.id_outlet = this.invoiceData.dataInvoice.idoutlet;
        },
        async onSave(is_with_ambil) {
            this.bayar.is_with_ambil = is_with_ambil;
            let {
                bayar,
                page: { from_route },
            } = this;
            let backIdx = from_route === "invoice.create" ? -3 : -1;

            await this.updateBayar();
            if (!bayar.idjenisbayar) {
                return this.$toast.warning("Mohon pilih metode pembayaran terlebih dahulu.!");
            }

            if (bayar.idjenisbayar === 3) {
                if (bayar.d_idakunbank === "") {
                    this.$toast.warning("Mohon pilih tujuan transfer terlebih dahulu.!");
                    return;
                }
            }

            let posted = new FormData();

            Object.keys(bayar).forEach((key) => {
                if (key === "dokumentasi") {
                    if (bayar[key].length > 0) {
                        bayar[key].forEach((dtImg) => {
                            posted.append(key, dtImg);
                        });
                    }
                } else {
                    posted.append(key, bayar[key]);
                }
            });

            this.setSaving(true);
            this.pembayaranInvoice(posted)
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { data, status, msg, code } = res.data;
                        if (status && code === 200) {
                            this.goInvoiceDone();
                            this.$toast.success(msg);
                        } else {
                            this.$toast.error(msg);
                        }
                    }
                    this.setSaving(false);
                })
                .catch((e) => {
                    this.setSaving(false);
                    this.$toast.error(e);
                });
        },

        setCssSelected() {
            let elSelected = document.getElementsByClassName("selected");
            let elUnselect = document.getElementsByClassName("unSelect");

            if (elSelected) {
                elSelected[0].firstChild.firstChild.style.backgroundColor = "#edf5ff";
                elSelected[0].firstChild.firstChild.style.borderColor = "#206CFF";
            }

            if (elUnselect) {
                elUnselect.forEach((element) => {
                    element.firstChild.firstChild.style.backgroundColor = "#ffffff";
                    element.firstChild.firstChild.style.borderColor = "#c8d0dd";
                });
            }
        },
    },
};
</script>
<style scoped src="../static/style.css"></style>
<style scoped>
.floating-btn {
    position: fixed;
    bottom: 65px;
    width: 100%;
    background-color: white;
    z-index: 200;
}
.fullScreen {
    padding-left: 0px;
    padding-right: 0px;
    margin-top: -52px;
}
.dNone {
    display: none;
}
.nominal-settlement {
    border: 1px solid #c8d0dd;
    padding: 8px 16px;
    border-radius: 4px;
}
.cam2 {
    margin-top: -120px;
    margin-left: -20px;
    position: absolute;
    width: 100vw;
    z-index: 200;
}
.mT35 {
    margin-top: -135px;
}
</style>
